// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__seY+4","closeModalIcon":"PopUpModal_closeModalIcon__VLSJz"};